import { useEffect, useMemo, useState } from 'react';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { getInitialValues } from 'hb-react/shared/apps/Events/pages/Booking/pages/BillingInformation/utils';
import { Select } from 'hb-react/shared/components/formik/components/inputs';
import type { AddressAttributes } from 'hb-react/shared/components/ShoppingCard/hooks/v2';
import type { User } from 'hb-react/types';

const SelectAddress = ({
  currentUser,
  setSelectedAddress,
  values,
}: {
  currentUser: User;
  setSelectedAddress: (address: AddressAttributes) => void;
  values: any;
}) => {
  const [address, setAddress] = useState('personal');

  const {
    currentNetwork: { user_fields_config: userFieldsConfig },
  } = useDefaultAppContexts();

  useEffect(() => {
    if (address) {
      const {
        receipt: { billing_address_attributes: billingAddressAttributes },
      } = getInitialValues(
        { currentUser, values },
        { selectedAddress: address },
      );

      setSelectedAddress(billingAddressAttributes);
    }
  }, [address]);

  const selectAddressOptions = useMemo(
    () => ({
      personal:
        userFieldsConfig?.postal_personal_label ||
        I18n.t('web.networks.events.receipt.billing_location.postal_address'),
      work:
        userFieldsConfig?.postal_work_label ||
        I18n.t('web.networks.events.receipt.billing_location.work_address'),
    }),
    [userFieldsConfig],
  );

  return (
    <Select
      name="receipt[address_type]"
      options={selectAddressOptions}
      placeholder={__('Select address')}
      label={__('Choose address')}
      onChange={({ value }) => setAddress(value)}
      wrapperProps={{ mb: 0, width: '100%' }}
    />
  );
};

export default SelectAddress;
